<template lang="html">
    <div class="bg-lightest col-sm-12 py-2">
        <div v-if="!showPromocodeWindow" class="d-flex align-items-center">

            <div class="d-flex flexGrow1 text-uppercase d-flex flex-column">
                <div class="dark bold">Discount</div>
                <div v-if="enablePromocode && !validPromocode" class="color-1 pointer" @click="togglePromocodeWindow('open')"><i class="fas fa-plus-circle"></i> Add Promocode</div>
                <div v-if="validPromocode" class="bold color-1">{{validPromocode.code}}</div>
            </div>

            <div v-if="!validPromocode" class="d-flex justify-content-end align-items-center">
                <div class="d-flex align-items-center">
                    <input type="number" class="glued-right px-2 py-1 text-right" style="width: 70px;" placeholder="0" v-model="reservation.attachDiscount.value" @change="discountChanged">
                    <div class="glued-left border-left-light py-1 px-2 pointer" @click="switchDiscountType" >{{reservation.attachDiscount.valueType == 1? '%':'€'}}</div>
                </div>
            </div>

            <!-- If we have a valid code we show the value and add a cross to remove the code -->
            <div v-if="validPromocode" class="d-flex justify-content-end align-items-center">
                <i class="fas fa-times dark pointer fs-larger" @click="removePromocode()"></i>
                <div>{{validPromocode.value + (validPromocode.amountType == 0? '€':'%')}}</div>
            </div>

        </div>

        <div v-if="showPromocodeWindow" class="row floatPrmocodeWindow">

            <div class="col-sm-12">
                <div class="row d-flex align-items-center mt-2">
                    <div class="col-sm-8">
                        <span class="text-uppercase dark bold">Insert your promocode</span>
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <i class="fas fa-times dark pointer" @click="togglePromocodeWindow('close')"></i>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 mt-2">
                <span v-if="showPromocodeInvalid" class="color-6">Invalid code, please try again.</span>
                <input type="text" placeholder="ex: PROMO10" class="fs-large text-center w-100" :class="{'border-color-6':showPromocodeInvalid}" v-model="tempPromocode"></input>
                <button class="btn blue w-100 wide mt-2" @click="applyCode">Apply</button>
            </div>

        </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
    props: {
        reservation: {
            type: Object
        },
        enablePromocode: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            showPromocodeWindow: false,
            tempPromocode: null,
            isPromocodeTested: false,
            isPromocodeInvalid:false,
            validPromocode: null
        }
    },
    computed: {
        showPromocodeInvalid: function () {
            return this.isPromocodeTested && !this.isPromocodeInvalid
        }
    },
    methods: {
        ...mapActions([
            'testPromocode',
            'setReservationCalculations'
        ]),
        updateCalculations: function () {
            this.setReservationCalculations(this.reservation)
        },
        switchDiscountType: function() {
            if(this.reservation.attachDiscount.valueType == 0){
                this.reservation.attachDiscount.valueType = 1
            } else {
                this.reservation.attachDiscount.valueType = 0
            }

            this.updateCalculations()
        },
        togglePromocodeWindow: function (state) {
            if(typeof state == 'string'){
                if(state == 'open'){
                    this.showPromocodeWindow = true
                } else if (state == 'close') {
                    this.showPromocodeWindow = false
                }
            } else {
                this.showPromocodeWindow = !this.showPromocodeWindow
            }
        },
        applyCode: function () {
            this.testPromocode(this.tempPromocode).then(response => {
                this.isPromocodeTested = true
                if(response.data && response.data.id){
                    let foundPromocode = response.data //store found code
                    let errorsArray = []
                    let promocodeIsValid = false
                    
                    // ok so we have a valid code, lets check if this code applies to this product
                    if(
                        foundPromocode &&
                        (
                            foundPromocode.isForAllProducts == true ||
                            foundPromocode.products.find(product => {return product.id == this.reservation.product.id})
                        )
                    ){
                        promocodeIsValid = true
                    } else {
                        errorsArray.push('This promocode does not apply to this product')
                    }

                    // check if today date is inside valid booking period
                    if(
                        moment().isSameOrAfter(moment(foundPromocode.bookingPeriodStart)) &&
                        moment().isSameOrBefore(moment(foundPromocode.bookingPeriodFinish))
                    ){
                        promocodeIsValid = true
                    } else {
                        errorsArray.push('Outside valid booking period')
                    }

                    // check if event date is inside valid period
                    if(
                        moment(this.reservation.event.start).isSameOrAfter(moment(foundPromocode.validPeriodStart)) &&
                        moment(this.reservation.event.start).isSameOrBefore(moment(foundPromocode.validPeriodFinish))
                    ){
                        // Check hour
                        if(
                            moment(this.reservation.event.start).format('HH:mm:ss') >= foundPromocode.validPeriodStartTime &&
                            moment(this.reservation.event.start).format('HH:mm:ss') <= foundPromocode.validPeriodFinishTime
                        ){
                            promocodeIsValid = true
                        } else {
                            errorsArray.push('Event start hour is outside valid period')
                        }
                    } else {
                        errorsArray.push('Event start date is outside valid period')
                    }

                    // check if the

                    if(errorsArray.length == 0){
                        this.validPromocode = foundPromocode //store found code
                        this.isPromocodeInvalid = false
                        this.addPromocodeToReservation(this.validPromocode.code)
                        this.togglePromocodeWindow('close')
                        this.updateCalculations()
                    } else {
                        this.$toasted.error(errorsArray[errorsArray.length - 1]);
                        this.isPromocodeInvalid = true
                    }


                } else {
                    this.$toasted.error('Promocode not found');
                    this.isPromocodeInvalid = true
                }
            })
        },
        discountChanged: function() {
            if(this.reservation.attachDiscount.valueType == 1 && (this.reservation.attachDiscount.value > 100 || this.reservation.attachDiscount.value < 0)){
                this.$toasted.error('Discount must be between 0 and 100%');
                this.reservation.attachDiscount.value = null
                return false
            }
            if(this.reservation.attachDiscount.valueType == 0 && this.reservation.attachDiscount.value < 0){
                this.$toasted.error('Discount must be higher than 0');
                this.reservation.attachDiscount.value = null
                return false
            }
            this.updateCalculations()
        },
        removePromocode: function () {
            this.validPromocode = null
            this.isPromocodeTested = false
            this.tempPromocode = null
            this.removePromocodeFromReservation()
            this.updateCalculations()
        },
        addPromocodeToReservation: function (promocode) {
            this.$set(this.reservation, 'attachPromocode', promocode)
        },
        removePromocodeFromReservation: function () {
            this.$set(this.reservation, 'attachPromocode', null)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.floatPrmocodeWindow{
    background-color: $lightest;
    // position: relative;
    // top: -25px;
    // box-shadow: 0px -4px 5px 0px transparentize($medium, 0.4);
}
</style>



// WEBPACK FOOTER //
// promocodeInput.vue?5aa89d9a